module.exports = __webpack_public_path__ + "img/slick_right_thin_white.f60157fa.svg";